/*
    Simplr shares one externalTicketId namespace across every client system, so a raw workspace
    sessionId can collide with an id another client sends (e.g. an IVR contact/call id for the
    same call). Suffix every id we hand to Simplr so our tickets are always our own.
*/
const SOLVE_GUIDE_TICKET_SUFFIX = "_solveGuide";

export function toSimplrTicketId(sessionId: string) {
    return `${sessionId}${SOLVE_GUIDE_TICKET_SUFFIX}`;
}
